var clientWidth = window.innerWidth || document.documentElement.clientWidth;
var scrollTop = window.scrollY || document.documentElement.scrollTop;
var topBarHeight = 0;

var typed = new Typed(".change", {
  strings: [
    "Bold",
    "Sassy",
    "Romantic",
    "Refined",
    "Quirky",
    "Raw",
    "Balanced",
    "Radiant",
    "Colorful",
    "Fizzy",
    "Blushing",
    "Serene",
    "Pastel",
    "Soft",
    "Dreamy",
    "Breezy",
    "Linen",
  ],
  typeSpeed: 50,
  backSpeed: 50,
  loop: true,
});

// var TH_Collections = new Swiper(".TH_Collections .bannerSwiper-container", {
//   freeMode: true,
//   width: 160,
//   slideToClickedSlide: false,
//   simulateTouch: false,
//   slidesOffsetAfter: -$(".TH_CollectionsContainer").width() + 160,
//   direction: "horizontal",
//   spaceBetween: clientWidth > 1280 ? 8 : 0,
//   navigation: {
//     nextEl: ".TH_Collections .arrow_next",
//     prevEl: ".TH_Collections .arrow_prev",
//   },
//   scrollbarHide: false,
//   scrollbarDraggable: true,
//   scrollbarSnapOnRelease: true,
//   scrollbar: {
//     el: ".TH_Collections .swiper-scrollbar",
//     draggable: true,
//     snapOnRelease: false,
//   },
//   observer: true, //开启动态检查器
// });

// definedByYou1 start
const socialList = [
  {
    msg: `What a stunning view by @alyssakirk.home !<br /><br />Product: Silhouette Linen Blend Woven Sheer Custom Curtain<br />Color: Silhouette / Sand<br />Header: Double French Pinch Pleat`,
    productList: [{
      id: "64172",
      imgSrc: "/cdn/shop/files/20250515-Aivory-2_2_-1_resolution-standardv2-2x.jpg",
      Fabrics: ["Silhouette"],
      subheading: "Linen Blend Woven Sheer Custom Curtain",
      ProductUrl: "/products/silhouette-linen-blend-woven-sheer-custom-curtain?selectcolor=Sand",
    },],
    poster: "",
    videoSrc: "https://cdn.shopify.com/videos/c/o/v/f9c2473e3724460db8cb58fb8e237ee8.mp4",
  },
  {
    msg: `Bare windows or dressed with curtains—what's your pick? 🪟✨<br />We're loving how @Omabelle transformed her space with our Zoe Linen Look Soft Custom Curtains in Ivory White. The warm, cozy vibe of these drapes truly makes a house feel like home, tying everything together effortlessly.<br /><br />🛒 Product Details:<br />Name: Zoe Linen Look Soft Custom Curtain<br />Pleat Style: Inverted Box Pleat<br />Color: Ivory White<br />Size: 100in width x 240in length<br /><br />🌟 TheHues' curtains are designed for luxury, comfort, and timeless style—an essential for every space.`,
    productList: [{
      id: "36313",
      imgSrc: "/cdn/shop/files/A1-layer-2-scaled_1__resolution-standardv2-2x.jpg",
      Fabrics: ["Zoe"],
      subheading: "Linen Look Soft Custom Curtain",
      ProductUrl: "/products/zoe-linen-look-soft-custom-curtain",
    },],
    poster: "",
    videoSrc: "https://cdn.shopify.com/videos/c/o/v/53791fcf43ae49299be71493162f7ffe.mp4",
  },
  {
    msg: `A Fresh Entryway Glow-Up! ✨<br /><br />@theblushhome completely transformed her entryway with a few simple changes, and the result is stunning! Freshly painted doors, adorable new closet knobs (bunny-shaped—how cute?!), and of course, the perfect finishing touch—custom curtains from TheHues. 🤍<br /><br />Look closely, and you’ll spot the delicate bird print on these beauties, bringing a subtle yet charming touch of spring into the space! Paired with a washable layered rug, this entryway is both stylish and functional—ready to handle all the daily hustle while looking effortlessly chic. 🌿<br /><br />🛒 Product Details:<br /><br />Name: Peacock Linen Blend Heavyweight Floral Patterned Custom Curtain<br />Color: Peacock / Fall<br />Header Style: Double French Pinch Pleat<br /><br />Name: Antique Terracotta Washable Area Rug`,
    productList: [{
      id: "64162",
      imgSrc: "/cdn/shop/files/20250116-Afall-3-1_resolution-standardv2-2x-2.jpg",
      Fabrics: ["Peacock"],
      subheading: "Linen Blend Heavyweight Floral Patterned Custom Curtain",
      ProductUrl: "/products/peacock-linen-blend-heavyweight-floral-patterned-custom-curtain",
    }],
    poster: "/cdn/shop/files/page_social_Peacock.png",
    videoSrc: "https://cdn.shopify.com/videos/c/o/v/33146098e5794a1f826f5d43b4a97624.mp4",
  },
  {
    msg: `Snowy Dreams by @jennifer__hagler! ❄️✨<br />Such a perfect winter wonderland, creating a dreamy and peaceful atmosphere!<br /><br />Collection: Tehreem - Textured Sheer Custom Curtain<br />Color: Tehreem / Beige<br />Header Style: 4-in-1`,
    productList: [{
      id: "1169",
      imgSrc: "/cdn/shop/files/20250515-Astone-blue-1_1__resolution-standardv2-2x.jpg",
      Fabrics: ["Tehreem"],
      subheading: "Textured Sheer Custom Curtain",
      ProductUrl: "/products/tehreem-textured-sheer-custom-curtain",
    },],
    poster: "",
    videoSrc: "https://cdn.shopify.com/videos/c/o/v/186598435d2a46dd88114e55dab0ff94.mp4",
  },
  {
    msg: `Completely Obsessed with These Curtains! 😻✨<br /><br />@anna_homme1 just elevated her living room with our Zoe Linen Look Soft Custom Curtains in Ivory White, and we can’t get enough! The soft, elegant fabric adds a whole new vibe to the space, making it feel fresh and cozy. Whether you're looking for a custom fit or a pop of timeless style, @thehues_home has everything you need. Quality meets value every time! 💫<br /><br />🛒 Product Details:<br /><br />Name: Zoe Linen Look Soft Custom Curtain<br />Color: Zoe / Ivory White<br />Header Style: Grommet Top Silver`,
    productList: [{
      id: "36313",
      imgSrc: "/cdn/shop/files/A1-layer-2-scaled_1__resolution-standardv2-2x.jpg",
      Fabrics: ["Zoe"],
      subheading: "Linen Look Soft Custom Curtain",
      ProductUrl: "/products/zoe-linen-look-soft-custom-curtain",
    },],
    poster: "",
    videoSrc: "https://cdn.shopify.com/videos/c/o/v/77b3ccec394247b2a7be3513fe604d47.mp4",
  },
  {
    msg: `"I've Got a Pocketful of Dreams" playing in the background while this dreamy room comes together has us all smiles! 🥳 We're so excited to see our linen blackout curtains adding cozy charm to @thrifty_abode beautiful space. The ivory white with Inverted Box Pleat is such a perfect fit! 👌<br /><br />It's amazing how a few thoughtful updates can transform a room into something truly special. 💕 We’re grateful to be part of this lovely home journey! 🏡✨<br /><br />🛒 Product Details:<br />Name: Zoe Linen Look Soft Custom Curtain<br />Color: Ivory White<br />Header: Inverted Box Pleat`,
    productList: [{
      id: "36313",
      imgSrc: "/cdn/shop/files/A1-layer-2-scaled_1__resolution-standardv2-2x.jpg",
      Fabrics: ["Zoe"],
      subheading: "Linen Look Soft Custom Curtain",
      ProductUrl: "/products/zoe-linen-look-soft-custom-curtain",
    },],
    poster: "",
    videoSrc: "https://cdn.shopify.com/videos/c/o/v/fb2184b25dab4c949a69ea62d7a33c08.mp4",
  },
  {
    msg: `'Like the smooth rhythm of jazz, we bring timeless elegance to your space.'🌿<br />Our Glint Linen Blend Custom Curtain in Cream brings an inviting sophistication to🎥:@sagarikas_ds s space, perfectly blending modern simplicity with a subtle touch of ethnic charm. The linen-like texture captures the essence of curated, eclectic decor, enhancing indoor warmth while framing the lush greenery outside. ✨This curtain is ideal for those seeking a unique and refined aesthetic, transforming your room into a serene sanctuary where style meets personality.😍<br /><br />🛒Product Details:<br />Name: Glint Linen Blend Custom Curtain<br />Pleat Style: Triple French Pinch Pleat<br />Color: Cream<br />Size: 44in width x 98in length<br />Features: Memory-trained pleats`,
    productList: [{
      id: "64175",
      imgSrc: "/cdn/shop/files/20250116-ACream-2-1_resolution-standardv2-2x-2.jpg",
      Fabrics: ["Glint"],
      subheading: "Linen Blend Shimmering Textured Custom Curtain",
      ProductUrl: "/products/glint-linen-blend-shimmering-textured-custom-curtain",
    },],
    poster: "",
    videoSrc: "https://cdn.shopify.com/videos/c/o/v/20c702358339475e86518157ff793900.mp4",
  },
  {
    msg: `Excited to see @our.nohai.home bring a fresh look to their living room with our Ivy Textured blackout curtains in Oatmeal! 🤍 The warm, textured tones add so much depth and elegance to the space, making it perfect for the holiday season ahead! ✨<br /><br />Ivy textured<br />Oatmeal color<br />40x84 inches<br />Triple pleat<br />Black out<br />`,
    productList: [{
      id: "95271",
      imgSrc: "/cdn/shop/files/20250115-AMoss-2-1_resolution-standardv2-2x.jpg",
      Fabrics: ["Ivy"],
      subheading: "Linen Look Heavyweight Herringbone Textured Custom Curtain",
      ProductUrl: "/products/ivy-linen-look-heavyweight-herringbone-textured-custom-curtain",
    },],
    poster: "",
    videoSrc: "https://cdn.shopify.com/videos/c/o/v/9a190a16c53c4b20ba756b3132330e5e.mp4",
  },
  {
    msg: `Halloween is here—time to elevate your space with a touch of spooky elegance! 🎃🕸️<br />Our Zoe Linen Look Soft Custom Curtain in Ivory White is the perfect addition to @poppies_home 's Halloween decor, effortlessly blending style and seasonal charm. 👻The Triple French Pinch Pleat design offers a polished, tailored look that enhances the cozy, classic atmosphere of your home. It’s ideal for transforming any corner into a warm and inviting spooky retreat! 🍂✨<br /><br />🛒 Product Details:<br />Name: Zoe Linen Look Soft Custom Curtain<br />Pleat Style: Triple French Pinch Pleat<br />Color: Ivory White<br />Size: 110in width x 104in length`,
    productList: [{
      id: "36313",
      imgSrc: "/cdn/shop/files/A1-layer-2-scaled_1__resolution-standardv2-2x.jpg",
      Fabrics: ["Zoe"],
      subheading: "Linen Look Soft Custom Curtain",
      ProductUrl: "/products/zoe-linen-look-soft-custom-curtain",
    },],
    poster: "/cdn/shop/files/page_social_img16.png",
    videoSrc: "https://cdn.shopify.com/videos/c/o/v/e11f6f1d36c442af8eed7562b5465ef0.mp4",
  },
  // {
  //   msg: `Bring a soft touch of pink and a playful vibe to any space! 🎀✨<br />@myvisionofhome has added the perfect blend of sweetness and style with TheHues’ Alice Dotted Patterned Heavyweight Soft Textured Custom Curtains in pink. 💫The delicate, tiny dots and the subtle hint of pink create a warm and welcoming feel, ideal for a girl’s room or any spot that could use a cozy update. With tailored Double French Pinch Pleats, these curtains add just the right amount of elegance while keeping things light and playful.🧸<br /><br />🛒 Product Details:<br />Name: Alice Dotted Patterned Heavyweight Soft Textured Custom Curtain<br />Pleat Style: Double French Pinch Pleat<br />Color: Pink<br />Size: 51in width x 91in length`,
  //   productList: [{
  //     id: "64159",
  //     imgSrc: "/cdn/shop/files/Alice-Pink-1-500x500.png",
  //     Fabrics: ["Alice"],
  //     subheading: "Dotted Patterned Heavyweight Soft Textured Custom Curtains",
  //     ProductUrl: "/custom-curtains/custom-alice-textured-room-darkening-curtain/?fwidth=51&flength=91&lining=Unlined&step_color=Alice%20/%20Pink&hide_size=51%22%20*%2091%22;%E2%80%821%20Panel&options=[97020,331]",
  //   },],
  //   poster: "",
  //   videoSrc: "https://cdn.shopify.com/videos/c/o/v/b77c616ff9be4ee4a2c7b894ad827458.mp4",
  // },
  {
    msg: `🌟 Ready to fall in love with your space all over again? @homeinbloom_ just did, thanks to our gorgeous Kyoto Linen Curtains! 😍✨ Their breakfast nook has never looked cozier, and we’re swooning over the transformation! 🏡🤎<br />Our Sand Kyoto Linen Curtains with elegant double pleats are perfect for adding that warm, inviting vibe to any room. Whether it’s for a peaceful morning or a relaxing evening, these dreamy curtains elevate the ambiance effortlessly.<br /><br />📏 Size: 60" x 94"<br />🌿 Material: Kyoto 100% Linen<br />🤍 Color: Sand<br />Header: Double Pinch Pleat<br />Ready to create your own cozy corner? Tag us in your transformations!`,
    productList: [{
      id: "1218",
      imgSrc: "/cdn/shop/files/Awhite-2-5-1_1__resolution-standardv2-2x.jpg",
      Fabrics: ["Kyoto"],
      subheading: "100% Linen Semi Sheer Custom Curtain",
      ProductUrl: "/products/kyoto-100-linen-semi-sheer-custom-curtain",
    },],
    poster: "/cdn/shop/files/page_social_img18.png",
    videoSrc: "https://cdn.shopify.com/videos/c/o/v/2b89cd92669e47ad9311dd1eb966f584.mp4",
  },
  {
    msg: `Effortless Elegance, Delivered ✨<br />@anhelina_rezk transformed her space with our soft, luxurious pleated curtains, proving that a simple upgrade can make a big difference! No need for a complete makeover – the texture, quality, and style of these curtains speak for themselves.<br />What’s even better? Our custom curtains arrive ready to shine, as if they’ve just been freshly steamed – no wrinkles, no fuss, just instant elegance! 👐🏻<br /><br />🛒 Product Details:<br />Material: Ivy<br />Color: Ivy / Ivory<br />Header: Double French Pinch Pleat`,
    productList: [{
      id: "95271",
      imgSrc: "/cdn/shop/files/20250115-AMoss-2-1_resolution-standardv2-2x.jpg",
      Fabrics: ["Ivy"],
      subheading: "Linen Look Heavyweight Herringbone Textured Custom Curtain",
      ProductUrl: "/products/ivy-linen-look-heavyweight-herringbone-textured-custom-curtain",
    },],
    poster: "/cdn/shop/files/page_social_img19.png",
    videoSrc: "https://cdn.shopify.com/videos/c/o/v/8b3bd3e847b84f21b7394a4f2ce93c94.mp4",
  },
  {
    msg: `'A small, subtle change is all you need. '<br />@alyssakirk.home added a touch of soft, organic beauty to this space with our Silhouette linen blend woven sheer curtains – the perfect choice for an effortlessly calming vibe.<br />🤎 "What do you think? Comment below and let us know!<br />Collection: Silhouette linen blend woven sheer<br />Color: Sand<br />Header: Double French pinch pleat<br />Size: 100" wide x 108" long`,
    productList: [{
      id: "64172",
      imgSrc: "/cdn/shop/files/20250515-Aivory-2_2_-1_resolution-standardv2-2x.jpg",
      Fabrics: ["Silhouette"],
      subheading: "Linen Blend Woven Sheer Custom Curtain",
      ProductUrl: "/products/silhouette-linen-blend-woven-sheer-custom-curtain",
    },],
    poster: "",
    videoSrc: "https://cdn.shopify.com/videos/c/o/v/6e35896fef504f409c109bb5935ef2e5.mp4",
  },
  // {
  //   msg: `Soft, cozy, and oh-so-sweet! 💕✨<br />@myvisionofhome has added the perfect finishing touch to her little girl’s room with our Alice Dotted Patterned Curtains. 💫These custom curtains, decorated with soft pink polka dots, bring a charming, playful vibe that brightens the room and creates a cozy, inviting space. Perfect for making bedtime a little more magical!🧸<br /><br />🛒 Product Details:<br />Name: Alice Dotted Patterned Heavyweight Soft Textured Curtains<br />Pleat Style: Double French Pinch Pleat<br />Color: Pink<br />Size: 51" x 91"<br />Follow us for more inspiration! @thehues_home 🤩`,
  //   productList: [{
  //     id: "64159",
  //     imgSrc: "/cdn/shop/files/Alice-Pink-1-500x500.png",
  //     Fabrics: ["Alice"],
  //     subheading: "Dotted Patterned Heavyweight Soft Textured Custom Curtains",
  //     ProductUrl: "/custom-curtains/custom-alice-textured-room-darkening-curtain/?fwidth=51&flength=91&lining=Unlined&step_color=Alice%20/%20Pink&hide_size=51%22%20*%2091%22;%E2%80%821%20Panel&options=[97020,331]",
  //   },],
  //   poster: "",
  //   videoSrc: "https://cdn.shopify.com/videos/c/o/v/a6ec7eb657cf4320a5a181ff3104106e.mp4",
  // },
  // {
  //   msg: `A Woodland Retreat for Little Adventures 🌲🦊<br />After nearly 18 months in the making, @thegeorgeshome has transformed her son’s bedroom into a magical woodland escape, complete with our Ambient Linen Blend Jacquard curtains. These custom curtains bring a sense of calm and warmth to the space, with their luxurious triple pleat design and premium blackout quality—perfect for restful nights and cozy mornings.<br />🛒 Curtain Details:<br />Name: Ambient Linen Blend Jacquard Custom Curtain<br />Color: Ambient White<br />Pleat Style: Triple Pleat<br />Feature: Blackout<br />Ready to create your own dreamy retreat? Discover our custom curtain collections at www.thehues.comand make every room extraordinary! ✨`,
  //   productList: [{
  //     id: "95270",
  //     imgSrc: "/cdn/shop/files/Ambient-1-500x500.png",
  //     Fabrics: ["Ambient"],
  //     subheading: "Linen Blend Jacquard Custom Curtain",
  //     ProductUrl: "/custom-curtains/custom-ambient-linen-blend-textured-room-darkening-curtain/?step_color=Ambient%20/%20White&hide_size=52%22%20*%2084%22;%E2%80%821%20Panel&options=[97022,63753,96983]",
  //   },],
  //   poster: "",
  //   videoSrc: "https://cdn.shopify.com/videos/c/o/v/78c7faa3776747d6b9c3d6edebc86d75.mp4",
  // },
  {
    msg: `🎃✨ Elevate Your Halloween Decor with Glint ✨🎃<br />Our new Glint curtains are the perfect addition to your spooky season setup! With their subtle shimmer and rich texture, they add an enchanting vibe to your Halloween decor. Whether you're hosting a haunted house or just getting cozy, Glint brings that extra touch of magic to your space. 🕯️🧡<br /><br />📷 Cr: phelpsresidence<br />🛒: Custom Glint Linen Blend Light Filtering Curtain<br />Header：Grommet Top Silver Black<br />Fabric/Color: Sesame`,
    productList: [{
      id: "64175",
      imgSrc: "/cdn/shop/files/20250116-ACream-2-1_resolution-standardv2-2x-2.jpg",
      Fabrics: ["Glint"],
      subheading: "Linen Blend Shimmering Textured Custom Curtain",
      ProductUrl: "/products/glint-linen-blend-shimmering-textured-custom-curtain",
    },],
    poster: "",
    videoSrc: "https://cdn.shopify.com/videos/c/o/v/9417523134284227a45deebca24fa159.mp4",
  },
  {
    msg: `✨ Hello, weekend vibes with a touch of elegance! 🌿 We are absolutely loving how 🎥:@alabaster_and_pearls styled their office space with our stunning new custom curtains. The Jade Velvet Heavyweight Patterned Curtain (Jade / Stone Blue) adds the perfect blend of softness and sophistication to this chic setup. 💙<br />What do you think about their next step—choosing the perfect paint color to complement these beauties? Drop your favorite cozy neutrals or muted blues in the comments below! 🎨🖌️<br /><br />🛒<br />Collection: Jade Velvet Heavyweight Patterned Custom Curtain<br />Color: Jade / Stone Blue<br />Header Style: Back Tab`,
    productList: [{
      id: "64164",
      imgSrc: "/cdn/shop/files/20250516-ARose-2_resolution-standardv2-2x-2.jpg?v=1747980916&width=990",
      Fabrics: ["Jade"],
      subheading: "Velvet Toile Heavyweight Patterned Custom Curtain",
      ProductUrl: "/products/jade-velvet-toile-heavyweight-patterned-custom-curtain",
    },],
    poster: "",
    videoSrc: "https://cdn.shopify.com/videos/c/o/v/c3b5cce29ce549368978e85aadab4069.mp4",
  },
  {
    msg: `🖤✨ We’re loving this living room transformation! Our pleated, neutral-toned linen curtains truly bring an elegant and elevated touch to any space. 🤍 The perfect blend of style and quality, making a simple update feel like a whole new room! 🏡<br /><br />🛒 Curtain Details:<br />Name: Zoe Linen Look Soft Custom Curtain<br />Color: Ivory White<br />Pleat Style: Inverted Box Pleat`,
    productList: [{
      id: "36313",
      imgSrc: "/cdn/shop/files/A1-layer-2-scaled_1__resolution-standardv2-2x.jpg",
      Fabrics: ["Zoe"],
      subheading: "Linen Look Soft Custom Curtain",
      ProductUrl: "/products/zoe-linen-look-soft-custom-curtain",
    },],
    poster: "",
    videoSrc: "https://cdn.shopify.com/videos/c/o/v/3675d5f2248e48d19233d945c5bf6428.mp4",
  },
  // {
  //   msg: `Christmas Came Early! 🎄✨<br>@our1897vintagefarmhouse is ready to welcome the holiday season in style with our Tuscany Foil Printed Velvet Floral Patterned Custom Curtains! The rich damask pattern in Tuscany/Mustard adds a touch of old-world charm, transforming her French guest room into a cozy, festive haven. 🎁💙 Perfect for hosting guests and celebrating in style this Christmas! 🌟<br><br>🛒 Product Details:<br>Name: Tuscany Foil Printed Velvet Floral Patterned Custom Curtain<br>Color: Tuscany / Mustard<br>Header Style: Single Rod Pocket<br>Designed in Italy`,
  //   productList: [{
  //     id: "95289",
  //     imgSrc: "/cdn/shop/files/Tuscany-Red-1-500x500.png",
  //     Fabrics: ["Tuscany"],
  //     subheading: "Foil Printed Velvet Floral Patterned Custom Curtain | Designed in Italy",
  //     ProductUrl: "/custom-curtains/custom-tuscany-foil-printed-velvet-room-darkening-curtain/?lining=Unlined",
  //   },],
  //   poster: "",
  //   videoSrc: "https://cdn.shopify.com/videos/c/o/v/370ff1dc59fc4774845f50854f3f210d.mp4",
  // },
  {
    msg: `Holiday-Ready Haven Starts Here! 🎄✨<br><br>@ranjeeta.dhillon has transformed her space into the perfect seasonal retreat with our Cronin Linen Look Blackout Custom Curtains in Cronin/Natural. 🤍 The triple pleat header adds timeless elegance, while the cozy fabric brings warmth and charm to her festive decor. It's all about those perfect details that make a house feel like home this holiday season. 🕯️<br><br>🛒 Product Details:<br>Name: Cronin Linen Look Blackout Custom Curtains<br>Color: Cronin / Natural<br>Header Style: Triple Pleat<br>Size: 50in width x 93in length (Single Panel)<br>Liner Type: No liner<br><br>Is your home holiday-ready? Share your favorite decor inspiration below! 🎁✨`,
    productList: [{
      id: "31662",
      imgSrc: "/cdn/shop/files/Acamel-2-3-2_resolution-standardv2-2x.jpg",
      Fabrics: ["Cronin"],
      subheading: "Linen Look Blackout Custom Curtain",
      ProductUrl: "/products/cronin-linen-look-blackout-custom-curtain",
    },],
    poster: "",
    videoSrc: "https://cdn.shopify.com/videos/c/o/v/78f1a41a41d44f20beed28212fc0e6b0.mp4",
  },
  {
    msg: `Cozy Up for the Holidays with Luxe Textures and Festive Cheer!🎄✨<br><br>@kassandradekoning has turned her home into a holiday wonderland with beautiful Christmas decor and our Custom Natural Oatmeal Color Room Darkening Linen Blend Curtains paired with Checkerboard Faux Fur Throw Blankets. 🎅The natural-toned curtains bring warmth and elegance with their Double Pinch Pleat design, while the soft, textured throw blankets in Almond Moss, Dark Gray, and Ivory add comfort to every corner. Surrounded by twinkling lights and festive decorations, this setup is the perfect way to embrace the holiday spirit! ❄️✨<br><br>🛒 Product Details:<br>💫Name: Checkerboard Baron Faux Fur Throw Blanket<br>Color: Almond Moss, Dark Gray, Ivory<br>Size: 60in width x 80in length`,
    productList: [{
      id: "1219",
      imgSrc: "/cdn/shop/files/20250206-Anatural-1-2_resolution-standardv2-2x.jpg",
      Fabrics: ["Venetian"],
      subheading: "Linen Blend Heavyweight Textured Custom Curtain",
      ProductUrl: "/products/venetian-linen-blend-heavyweight-textured-custom-curtain",
    },],
    poster: "",
    videoSrc: "https://cdn.shopify.com/videos/c/o/v/11ac30bccf0647caa2f8dd771e7b8bf8.mp4",
  },
  // {
  //   msg: `The Secret to a Perfectly Styled Room? Curtains! ✨<br><br>@leahwhitehome proves just how much window treatments can elevate a space! 🙌 These custom Lana Cotton Blend Lightweight Textured Custom Curtains from @thehues_home are truly a game changer, bringing texture, warmth, and sophistication to every corner of this room. The triple pinch pleat design adds a touch of refined elegance, making this space feel complete. 🏡💫<br><br>🛒 Product Details:<br>Name: Lana Cotton Blend Lightweight Textured Custom Curtain<br>Color: Lana / Beige<br>Header Style: Triple Pinch Pleat`,
  //   productList: [{
  //     id: "95283",
  //     imgSrc: "/cdn/shop/files/Pink-1-500x500.png",
  //     Fabrics: ["Lana"],
  //     subheading: "Cotton Blend Lightweight Textured Custom Curtain",
  //     ProductUrl: "/custom-curtains/custom-lana-textured-room-darkening-curtain/?step_color=Lana%20/%20Pink&fwidth=21&flength=21&hide_size=21%22%20*%2021%22;%E2%80%821%20Panel&options=[342,96770,331]",
  //   },],
  //   poster: "",
  //   videoSrc: "https://cdn.shopify.com/videos/c/o/v/48c942ed75484ede82b888a414f0d11f.mp4",
  // },
  {
    msg: `Get Your Home Holiday-Ready with the Perfect Curtains! 🎄✨<br><br>With Christmas just around the corner, it's time to elevate your space with some festive flair. @yasmin_homeideas has done it again with a stunning holiday transformation featuring our Zoe Linen Look Soft Custom Curtains in Ivory White. The luxurious Double French Pinch Pleat adds a touch of elegance, while the soft, timeless color creates a cozy backdrop for all your Christmas decorations—whether it's twinkling lights or festive garlands. These curtains pair perfectly with a beautiful Christmas tree, making them the ideal choice for this holiday season!🎅<br><br>🛒 Product Details:<br>Name: Zoe Linen Look Soft Custom Curtain<br>Pleat Style: Double French Pinch Pleat<br>Color: Ivory WhiteSize: 100in width x 94in length<br>Accessories: Beige White Woven Single Ball Curtain Tiebacks (2PCS)<br><br>Add warmth and style to your home this holiday season with TheHues curtains—available now at http://www.thehues.com🎁✨`,
    productList: [{
      id: "36313",
      imgSrc: "/cdn/shop/files/A1-layer-2-scaled_1__resolution-standardv2-2x.jpg",
      Fabrics: ["Zoe"],
      subheading: "Linen Look Soft Custom Curtain",
      ProductUrl: "/products/zoe-linen-look-soft-custom-curtain",
    },],
    poster: "/cdn/shop/files/page_social_img8.png",
    videoSrc: "https://cdn.shopify.com/videos/c/o/v/7e756a66e5fe49f189e2b612dd49cc36.mp4",
  },
];
var definedByYouProductList = [];
var socialInitArr = [
  "1169",
  "95270",
  "64175",
  "95271",
  "36313",
  "64159",
  "1218",
  "95286",
  "64172",
  "64164",
  "55843",
  "64162",
];

// var definedByYou = new Swiper(".definedByYou1 .bannerSwiper-container", {
//   direction: "horizontal",
//   slidesPerView: clientWidth > 960 ? 3 : 1.5,
//   simulateTouch: false,
//   slideToClickedSlide: false,
//   spaceBetween: 20,
//   scrollbarHide: false,
//   scrollbarDraggable: true,
//   scrollbarSnapOnRelease: false,
//   scrollbar: {
//     el: ".definedByYou1 .swiper-scrollbar",
//     draggable: true,
//     snapOnRelease: false,
//   },
//   observer: true, //开启动态检查器
// });

$(
  ".definedByYouPopup .rectangle,.definedByYouPopup .rectangle .popupBox > .item .exit"
).on("click", function () {
  $(".definedByYouPopup").find("video")[0].pause();
  $("html").css("overflow", "");
  $(
    ".definedByYouPopup .rectangle .popupBox>.item .popupDetails .productList, .definedByYouPopup .rectangle .popupBox>.item .popupDetails .details"
  ).css("display", clientWidth < 960 ? "none" : "flex");
  $(".definedByYouPopup").css("display", "none");
});

$(".definedByYouPopup .rectangle .popupBox").on("click", function (e) {
  e.stopPropagation();
});

$(
  ".definedByYou1 .content .definedByYouBox > .item:last-of-type > .banner_slider .bannerSwiper-container .swiper-wrapper .swiper-slide .item .rectangle .itemCard"
).hover(
  function () {
    if (clientWidth > 960) {
      $(this).css("width", "100%");
      $(this).find(".productDetails").css({
        display: "flex",
        opacity: "1",
      });
    }
  },
  function () {
    $(this).css("width", "6.6rem");
    $(this).find(".productDetails").css({
      display: "none",
      opacity: "0",
    });
  }
);

$(
  ".definedByYou1 .content .definedByYouBox > .item:last-of-type > .banner_slider .bannerSwiper-container .swiper-wrapper .swiper-slide .item video"
).on("canplaythrough", function () {
  var isPlay = false;
  $(this)
    .closest(".itemBox")
    .on("mouseover", function () {
      $(this).find("video")[0].play();
    });
  $(this)
    .closest(".itemBox")
    .on("mouseout", function () {
      $(this).find("video")[0].pause();
    });
  $(this).on("play", function () {
    isPlay = true;
  });

  $(this).on("pause", function () {
    isPlay = false;
  });
});

async function definedByYouVideoproductInit() {
  definedItemBoxChange();

  const res = await fetchProductData({
    product_id: jQuery.unique([...socialInitArr]),
  });
  if (res?.data) {
    definedByYouProductList = pakoUnlock(res.data);
    definedItemBoxChange();
  }
}

function definedItemBoxChange() {
  var str = [];
  $.each(socialList, function (i, item) {
    str.push(`<div class="swiper-slide">`);
    str.push(`<div class="item">`);
    str.push(`<video loop muted control poster="${item.poster}">`);
    str.push(`<source src="${item.videoSrc}" type="video/mp4">`);
    str.push(`</video>`);
    str.push(`<div class="rectangle">`);
    str.push(`<div class="itemCardList">`);
    for (var i = 0; i < item.productList.length; i++) {
      str.push(
        `<a href="${item.productList[i].ProductUrl}" target="_blank" class="itemCard" data-id="${item.productList[i].id}">`
      );
      str.push(`<div class="itemContainer">`);
      str.push(
        `<div class="productImg"><img src="${item.productList[i].imgSrc}" /></div>`
      );
      str.push(
        `<div class="productDetails"><div class="productFabrics">${item.productList[i].Fabrics[0]}</div><div class="subheading">${item.productList[i].subheading}</div></div>`
      );
      str.push(`</div>`);
      str.push(`</a>`);
    }
    str.push(`</div>`);
    str.push(`<div class="videoDetails">`);
    str.push(`<div>`);
    str.push(`${item.productList[0].Fabrics[0]}`);
    str.push(`<a class="btn" type="link">Discover More</a>`);
    str.push(`</div>`);
    str.push(`<p>${item.msg}</p>`);
    str.push(`</div>`);
    str.push(`</div>`);
    str.push(`</div>`);
    str.push(`</div>`);
    str.push(`</div>`);
  });
  $(
    ".definedByYou1 .banner_slider .bannerSwiper-container .swiper-wrapper"
  ).html(str.join(""));
  // definedByYou.removeAllSlides();
  // definedByYou.appendSlide(str.join(""));
  // definedByYou.updateSlides();
  // definedByYou.slideTo(0, 0, false);
  $(
    ".definedByYou1 .content .definedByYouBox > .item:last-of-type > .banner_slider .bannerSwiper-container .swiper-wrapper .swiper-slide .item .rectangle .itemCard"
  ).on("click", function (event) {
    if ($(this).find(".productDetails").css("display") != "flex") {
      event.preventDefault();
      // 阻止事件冒泡
      event.stopPropagation();
      $(this).css("width", "100%");
      $(this).parent().find(".productDetails").css({
        display: "none",
        opacity: "0",
      });
      $(this).find(".productDetails").css({
        display: "flex",
        opacity: "1",
      });
    }
  });

  $(
    ".definedByYou1 .content .definedByYouBox > .item:last-of-type > .banner_slider .bannerSwiper-container .swiper-wrapper .swiper-slide .item .rectangle .itemCard"
  ).hover(
    function () {
      if (clientWidth > 960) {
        $(this).css("width", "100%");
        $(this).find(".productDetails").css({
          display: "flex",
          opacity: "1",
        });
      }
    },
    function () {
      $(this).css("width", "6.6rem");
      $(this).find(".productDetails").css({
        display: "none",
        opacity: "0",
      });
    }
  );

  $(
    ".definedByYou1 .content .definedByYouBox > .item:last-of-type > .banner_slider .bannerSwiper-container .swiper-wrapper .swiper-slide .item video"
  ).on("canplaythrough", function () {
    var isPlay = false;
    $(this)
      .closest(".item")
      .on("mouseover", function () {
        $(this).find("video")[0].play();
      });
    $(this)
      .closest(".item")
      .on("mouseout", function () {
        $(this).find("video")[0].pause();
      });
    $(this).on("play", function () {
      isPlay = true;
    });

    $(this).on("pause", function () {
      isPlay = false;
    });
  });

  $(
    ".definedByYou1 .content .definedByYouBox > .item:last-of-type > .banner_slider .bannerSwiper-container .swiper-wrapper .swiper-slide .item .rectangle .videoDetails > div a"
  ).on("click", function () {
    const currentItem = $(this).closest(".swiper-slide");
    var item = $(".definedByYouPopup .rectangle .popupBox > .item");
    var productIds = [];
    item.find("video").attr("poster", currentItem.find("video").attr("poster"));
    item
      .find("video source")
      .attr("src", currentItem.find("video source").attr("src"));
    item.find("video")[0].load();
    item.find(".details p").html(currentItem.find(".videoDetails > p").html());
    item.find("video")[0].play();

    $.each(currentItem.find(".itemCard"), function (i, itemC) {
      productIds.push($(itemC).attr("data-id"));
    });
    $(".definedByYouPopup .productList").attr({
      "data-list": productIds,
      col: productIds.length,
    });
    productListCardChange(
      ".definedByYouPopup .productList",
      updateCardList(
        socialList[currentItem.index()].productList,
        definedByYouProductList
      )
    );
    currentItem.find("video")[0].pause();
    $("html").css("overflow", "hidden");
    $(
      ".definedByYouPopup .rectangle .popupBox>.item .popupDetails .productList, .definedByYouPopup .rectangle .popupBox>.item .popupDetails .details"
    ).css("display", clientWidth < 960 ? "none" : "flex");
    $(".definedByYouPopup").css("display", "block");

    item.find("video").on("canplaythrough", function () {
      var isPlay = true;
      $(this).on("click", function () {
        if (isPlay) {
          $(this)[0].pause();
        } else {
          $(this)[0].play();
        }
      });
      $(this).on("play", function () {
        isPlay = true;
      });

      $(this).on("pause", function () {
        isPlay = false;
      });
    });
  });
}

function productListCardChange(ele, definedByYouProductList) {
  var $productList = $(ele);
  $productList.each(function (i, ele) {
    if ($(ele).attr("data-list") != null) {
      const modelList = jQuery.unique($(ele).attr("data-list").split(","));
      const sameList = definedByYouProductList.filter(function (item) {
        return modelList.includes(item.id);
      });
      productCard(
        ele,
        listOrderByArr(sameList, modelList),
        {
          showType: [],
        },
        "Unlined"
      );
    }
  });
}

$(
  ".definedByYou1 .content .definedByYouBox > .item:last-of-type > .banner_slider .bannerSwiper-container .swiper-wrapper .item"
).hover(function () {
  $(this).find("video")[0].pause();
});

var $slidePercent = $(
  ".definedByYouPopup .rectangle .popupBox>.item .popupDetails"
);
var $slideArea = $(
  ".definedByYouPopup .rectangle .popupBox>.item .popupDetails .touchTheSlider"
);

var startY = 0;
var moveY = 0;
var y = 0;

// 触摸开始时记录初始位置
$slideArea.on("touchstart", function (e) {
  y = this.offsetTop;
  startY = e.originalEvent.touches[0].clientY;
  e.preventDefault(); //阻止屏幕滚动的默认行为
});

// 触摸移动时计算当前位置
$slideArea.on("touchmove", function (e) {
  moveY = e.originalEvent.touches[0].clientY;
  e.preventDefault(); //阻止屏幕滚动的默认行为
});

// 触摸结束时判断滑动方向
$slideArea.on("touchend", function (e) {
  if (moveY < startY) {
    // 向上滑动
    $slideArea.css({
      "padding-top": "0",
    });
    $slidePercent.find(".productList").css("display", "flex");
    $slidePercent.find(".productList, .details").slideDown(150, function () {
      $slideArea.animate(
        {
          paddingTop: "1.6rem",
        },
        150
      );
    });
  } else if (moveY > startY) {
    // 向下滑动
    $slideArea.css({
      "padding-bottom": "0",
    });
    $slidePercent.find(".productList, .details").slideUp(150, function () {
      $slideArea.animate(
        {
          paddingBottom: "1.6rem",
        },
        150
      );
    });
  }
  e.preventDefault(); //阻止屏幕滚动的默认行为
});

function autoScrollInit(e) {
  var $scrollable = $(e);
  var scrollInterval;
  var scrollSpeed = 1; // 滚动速度
  var isScrolling = true;

  // 自动滚动函数
  function autoScroll () {
    if (isScrolling) {
      var currentScroll = $scrollable.scrollLeft();
      $scrollable.scrollLeft(currentScroll + scrollSpeed);
    }
  }

  // 开始自动滚动
  function startAutoScroll () {
    scrollInterval = setInterval(autoScroll, 50);
  }

  // 停止自动滚动
  function stopAutoScroll () {
    clearInterval(scrollInterval);
  }

  // 初始化自动滚动
  startAutoScroll();

  // 鼠标移入时停止滚动
  $scrollable.on('mouseenter', function () {
    isScrolling = false;
  });

  // 鼠标移出时继续滚动
  $scrollable.on('mouseleave', function () {
    isScrolling = true;
  });
}
// definedByYou1 end

$(document).ready(function () {
  clientWidth = window.innerWidth || document.documentElement.clientWidth;
  scrollTop = window.scrollY || document.documentElement.scrollTop;
  topBarHeight = $(".top-bar").outerHeight();
  // definedByYouVideoproductInit();
  definedByYouProductList = listOrderByArr(filterStart.dataList, socialInitArr);
  definedItemBoxChange();
  autoScrollInit('.definedByYou1 .content .definedByYouBox>.item:last-of-type>.banner_slider .bannerSwiper-container .swiper-wrapper');
});
$(window).resize(function () {
  clientWidth = window.innerWidth || document.documentElement.clientWidth;
  topBarHeight = $(".top-bar").outerHeight();
});
$(window).scroll(function () {
  scrollTop = window.scrollY || document.documentElement.scrollTop;
});
